export const TYPE_SERVICE_BULLETIN = 'Service_Bulletin';
export const TYPE_COMPETITOR_COMPERISON = 'Competitor_Comparison';
export const TYPE_PRICE_LIST = 'Price_List';
export const TYPE_ORGINIAL_SERVICE_BULLETING = 'Service Bulletin';
